import React, { useEffect, useRef } from 'react';

import './Popup.css';
import kampanyaImage from '../../assets/img/tm7/thermomix-tm7-kasim-2025-kampanyasi.webp';

interface SecimPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onCopyToClipboard?: () => void;
}

const SecimPopup: React.FC<SecimPopupProps> = ({ isOpen, onClose, onCopyToClipboard }) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isOpen) {
      closeButtonRef.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;



  return (
    <div id="secim_popup" className={`popup-overlay ${isOpen ? 'open' : ''}`} style={{ zIndex: 9999999999 }} role="dialog" aria-modal="true" aria-labelledby="secim-popup-title">
      <div className="popup-backdrop" onClick={onClose} aria-label="Popup'u kapat"></div>
      <div className="popup-container secim-popup">
        <button
          className="popup-close"
          onClick={onClose}
          aria-label="Popup'u kapat"
          ref={closeButtonRef}
        >
          <svg clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#fff">
            <path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"></path>
          </svg>
        </button>
        <h2 id="secim-popup-title" className="popup-title">
          YENİ ÜRÜN, YENİ GÖRÜNÜM - <b className="font-bold">THERMOMİX TM7</b>
        </h2>
        <div className="popup-content secim-content">
          <div className="secim-image-container">
            <img
              src={kampanyaImage}
              alt="Kasım 2025 Kampanyası"
              loading="lazy"
              className="secim-image"
            />
            <div className="secim-details">
              <b>Detaylar;</b>
              <span>
                <b>1.</b> Thermomix TM7 fiyatı 74.990 TL'dir. Kasım ayı boyunca Thermomix TM7 için
                <b> Vade Farksız 6 Taksit</b> seçeneği bulunmaktadır.
              </span>
              <span>
                <b>2.</b> Kasım ayına özel 6990 TL değerindeki Kobold VM7 Şarjlı El Süpürgesi
                <b> 4000 TL</b>'dir. Kampanyadan yararlanmak için Whatsapp üzerinden iletişime geçebilir
                veya <a href="#bilgi-formu" className="popup-link" onClick={onClose}>Sipariş Formu</a>'nu doldurabilirsiniz.
              </span>

            </div>
          </div>
        </div>
        <a
          href="#bilgi-formu"
          className="secim-cta-btn"
          onClick={onClose}
          aria-label="Sipariş formuna git"
        >
          THERMOMİX TM7 SİPARİŞ OLUŞTUR
        </a>
      </div>
    </div>
  );
};

export default SecimPopup;

